import { Currency } from '@models/Currency'

export type TierKey = keyof Tier

export interface Tier {
  gold: [number, number]
  platinum: [number, number]
  platinumF: [number, number]
  sapphire: [number, number]
  sapphireF: [number, number]
  emerald: [number, number]
  emeraldF: [number, number]
  diamond: [number, number]
  diamondF: [number, number]
}

export interface BaseCountryData {
  country: Country
  region: Region
  currency: Currency
  ratioPVBV: number
  tiers: Tier
  bronzeFoundationMultiplier: number
  bronzeBuilderMultiplier: number
  bronzeBuilderConsistency: {
    multiplier6x: number
    multiplier12x: number
  }
  performanceBonus: {
    percent3: number
    percent6: number
    percent9: number
    percent12: number
    percent15: number
    percent18: number
    percent21: number
  }
  frontlineGrowthIncentiveAnnualVolume: number
  frontlineGrowthIncentiveAmountCap: number
  frontlineGrowthIncentiveRubyPVRequirement: number
}

export interface CountryData2024 extends BaseCountryData {
  personalGroupGrowth: {
    multiplierMaintain: number
    multiplierMaintain12: number
    multiplier1to2: number
    multiplier3to5: number
    multiplier6plus: number
  }
  frontlineGrowthIncentive: {
    multiplierMaintain: number
    multiplier1to2: number
    multiplier3to5: number
    multiplier6plus: number
  }
  performancePlusMonthlyVolume: number
  personalGroupGrowthAnnualVolume: number
}

export interface CountryData2025 extends BaseCountryData {
  frontlineGrowthIncentive: {
    multiplierMaintain: number
    multiplier1to5: number
    multiplier6plus: number
  }
  newPerformancePlusMonthlyPv: number
}

export enum Region {
  WE = 'Western Europe',
  CE = 'Central Europe',
  EE = 'Eastern Europe',
  SA = 'South Africa',
  ANZ = 'Australi & New Zealand'
}

export enum Country {
  AT = 'Austria',
  BE = 'Belgium',
  BG = 'Bulgaria',
  HR = 'Croatia',
  CZ = 'Czech Republic',
  DK = 'Denmark',
  EE = 'Estonia',
  FI = 'Finland',
  FR = 'France',
  DE = 'Germany',
  GR = 'Greece',
  HU = 'Hungary',
  IE = 'Ireland',
  IT = 'Italy',
  LT = 'Lithuania',
  LV = 'Latvia',
  NL = 'Netherlands',
  NO = 'Norway',
  PL = 'Poland',
  PT = 'Portugal',
  RO = 'Romania',
  SK = 'Slovak Republic',
  SI = 'Slovenia',
  ZA = 'South Africa',
  ES = 'Spain',
  SE = 'Sweden',
  CH = 'Switzerland',
  TR = 'Turkey',
  UA = 'Ukraine',
  GB = 'United Kingdom',
  NZ = 'New Zealand',
  AU = 'Australia'
}
